export const noop = Symbol("nexus-noop");
export const event = Symbol("nexus-event");
export const namespace = Symbol("nexus-namespace");
export const func = Symbol("nexus-function");

/**
 *
 */
export declare const $$__: unique symbol;
